<div class="user-docs-wrapper">
  <!-- Drag & Drop Overlay -->
  @if (isDraggingOver) {
    <div
      class="user-docs-drop-overlay"
      >
      <div class="user-docs-drop-overlay-inner">
        <i class="ri-file-upload-line"></i>
        <span i18n="@@user-docs-drop-hint">Dokument hier ablegen</span>
      </div>
    </div>
  }

  <button
    class="btn btn-sm btn-outline-secondary user-docs-toggle"
    type="button"
    (click)="togglePanel()"
    [tooltip]="panelOpen ? closeLabel : openLabel"
    placement="top"
    >
    <i class="ri-file-list-3-line"></i>
    @if (documents.length > 0) {
      <span
        class="user-docs-badge"
      >{{documents.length}}</span>
    }
  </button>

  @if (panelOpen) {
    <div
      class="user-docs-panel"
      >
      <div class="user-docs-panel-header">
        <span i18n="@@user-docs-panel-title">Meine Dokumente</span>
        <span class="user-docs-panel-limit text-muted">
          {{documents.length}}&nbsp;/&nbsp;{{limitLabel}}
        </span>
      </div>
      <!-- Upload Status -->
      @if (uploadStatus) {
        <div
          class="user-docs-status"
            [ngClass]="{
        'user-docs-status--uploading': uploadStatus.status === 'uploading',
        'user-docs-status--complete': uploadStatus.status === 'complete',
        'user-docs-status--error': uploadStatus.status === 'error'
      }"
          >
          <i
            class="me-1"
                [ngClass]="{
          'ri-loader-4-line spin': uploadStatus.status === 'uploading',
          'ri-checkbox-circle-line': uploadStatus.status === 'complete',
          'ri-error-warning-line': uploadStatus.status === 'error'
        }"
          ></i>
          @if (uploadStatus.status === 'uploading') {
            <span
              i18n="@@user-docs-uploading"
            >{{uploadStatus.filename}} wird verarbeitet…</span>
          }
          @if (uploadStatus.status === 'complete') {
            <span
              i18n="@@user-docs-upload-complete"
            >{{uploadStatus.filename}} wurde hinzugefügt.</span>
          }
          @if (uploadStatus.status === 'error') {
            <span>{{uploadStatus.message}}</span>
          }
        </div>
      }
      <!-- Dokument-Liste -->
      @if (!isLoading) {
        <div
          class="user-docs-list"
          >
          @if (documents.length === 0 && !uploadStatus) {
            <div
              class="user-docs-empty text-muted"
              >
              <i class="ri-inbox-line me-1"></i>
              <span i18n="@@user-docs-empty">Noch keine Dokumente vorhanden.</span>
            </div>
          }
          @for (doc of documents; track doc) {
            <div
              class="user-docs-item"
              >
              <i class="ri-file-text-line me-1 text-muted"></i>
              <span
                class="user-docs-item-name"
                [title]="doc.filename"
              >{{doc.filename}}</span>
              <button
                class="btn btn-sm btn-link text-danger p-0 ms-auto"
                type="button"
                (click)="deleteDocument(doc)"
                [attr.aria-label]="deleteLabel"
                >
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          }
        </div>
      }
      @if (isLoading) {
        <div
          class="user-docs-loading text-muted"
          >
          <i class="ri-loader-4-line spin me-1"></i>
          <span i18n="@@user-docs-loading">Wird geladen…</span>
        </div>
      }
      <!-- Upload-Button -->
      @if (uploadAllowed) {
        <div
          class="user-docs-upload"
          >
          <label
            class="btn btn-sm btn-primary w-100"
            for="user-doc-file-input"
            >
            <i class="ri-upload-line me-1"></i>
            <span i18n="@@user-docs-upload-btn">Dokument hochladen</span>
          </label>
          <input
            id="user-doc-file-input"
            type="file"
            class="d-none"
            [attr.accept]="acceptString"
            (change)="onFileSelected($event)"
            />
          <div class="text-muted small mt-1 text-center">
            @if (allowedTypesLabel) {
              <span>Erlaubt: {{allowedTypesLabel}}@if (botConfig.userDocumentsMaxMb > 0) {
                <span
                > · max. {{botConfig.userDocumentsMaxMb}} MB</span>
              }</span>
            }
          </div>
        </div>
      }
      @if (!uploadAllowed) {
        <div
          class="user-docs-upload text-muted small text-center"
          >
          <span i18n="@@user-docs-limit-reached">Limit erreicht. Lösche ein Dokument, um ein neues hochzuladen.</span>
        </div>
      }
    </div>
  }
</div>